<template>
    <div >
        <div id="wrapper" class="bg-golden" :class="{'long-name': longText}">
            <div id="bg-green-curve" class="bg-green m-auto">
                <div class="nv-wrapper" v-if="isShowBack">
                    <img class="back" v-if="isShowBack" src="../../../assets/icon/newversion/back-white.svg"  @click="clickBack" />
                    <div class="title text-white" v-if="pageName" v-html="pageName"></div>
                </div>
                <div class="nv-wrapper" v-if="page == 'surprisebox' && state == 'item'">
                    <img class="back" src="../../../assets/icon/newversion/back-white.svg"  @click="clickBack" />
                </div>
                <img class="logo img-fluid mx-auto" v-if="!pageName" src="../../../assets/icon/newversion/cpf_feed_logo.png" />
                <img class="cart img-fluid" v-if="isShowCart" src="../../../assets/icon/newversion/cart.svg"  @click="goShoppingCartProduct()"  />
            </div>
        </div>
        <!-- <div class="img_bottom_bar" v-if="isShowCurveBottom"></div> -->
    </div>
</template>
<script>
import Vue from 'vue';
import BzbsAuth from '@/core/Account/service/BzbsAuth.js';
import AccountMixin from "@/mixin/AccountMixin.js";
import { AccessKeyModel } from '@/core/Account/model/AccessKeyModel.js';
/**
 * @event switchLang
 * @event logout
 * @property {object} lbl (require)
 * @property {string} activeTab (optional)
 * @property {object} profile (require)
 * @property {boolean} isLogin (require)
 * @property {ModalController} modalController (optional)
 */
export default {
    name: 'nav-bar',// <top-bar>
    props: {
        pageName: String,
        page: String,
        state: String,
        userType: String,
        longText: Boolean,
        isShowBack: { type: Boolean, default: false },
        isShowCart: { type: Boolean, default: false },
        isShowCurveBottom: { type: Boolean, default: true },
    },
    mixins: [
        AccountMixin,
    ],
    mounted: function () {

    },
    data: function(){
        return{
            config: Vue.bzbsConfig,
        }
    },
    methods: {
        //Event
        clickBack: function () {
            this.$emit('clickBack');
        },
        getShoppingCartAccessKey: function(token) {
            return new Promise((resolve) => {
                let currentUrl = window.location.href
                let payload = {
                    returnUrl: currentUrl,
                    successUrl: currentUrl,
                    errorUrl: currentUrl,
                    appId: this.config.client_id,
                    appName: this.config.appname,
                    routeMode: 'push',
                }
                let jsonPayload = JSON.stringify(payload)
                BzbsAuth.apiCreateAccessKey(token, jsonPayload)
                    .then(res => {
                        let accessKey = new AccessKeyModel()
                        accessKey.setDataFromApi(res.data.data)
                        resolve(accessKey.accessKey);
                    }).catch(err => {
                        console.log(err);
                        resolve(null);
                    });
            })
        },
        checkConsentCookie: async function  () {
            const token = this.getToken();
            const currentVersion = await this.getCurrentVersion();
            const userConsent = await this.getUserConsent(token);

            if (currentVersion && userConsent) {
                this.currentVersion = currentVersion.data.cookie.current_version;
                this.userConsent = userConsent;

                if (this.currentVersion != userConsent.NecessaryCookies ||
                    this.currentVersion != userConsent.FunctionalCookies) {
                    this.showCookieModals();
                }
            }
        },
        goShoppingCartProduct: async function() {
            console.log('goShoppingCartProduct');
            let token = this.getToken();
            let accessKey = await this.getShoppingCartAccessKey(token)

            if (accessKey == null) {
                return
            }

            let appName = this.config.appname;
            let url = this.config.bzbNewShoppingCartUrl + `/landing/${appName}?access_key=${accessKey}&appname_config=${appName}`
            window.location.href = url
        },
        //Method
    }
}
</script>
<!-- <style lang="scss">
@import "./NavBar.scss";
</style> -->

<style lang="scss" scoped>
@import "@/style/base/common.scss";
#wrapper {
    width: 100%;
    height: 95px;

    &.bg-golden {
        background-image: url('../../../assets/image/Navbar/bg-curve-top-1.png');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center top;
    }
    #bg-green-curve {
        width: 100%;
        height: 80px;
        min-height: 70px;
        max-width: 500px;
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
        &.bg-green {
            background-image: url('../../../assets/image/Navbar/bg-top-curve.png');
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center top;
        }
    }
}
.nv-wrapper {
    display: flex;
    align-items: center;
    justify-content: justify-start;
    padding: 12px 16px;
}
.cart {
    position: absolute;
    right: 16px;
    top: 12px;
    width: 32px;
    height: 32px;
}
.logo {
    margin-top: 0;
    width: 40px;
    height: 40px;
}
.back {
    width: 24px;
    height: 24px;
    margin-right: 8px;
}
.title {
    font-size: 28px;
    font-style: normal;
    line-height: normal;
}
// .img_bottom_bar {
//     height: 90px;
//     width: 100%;
//     background: url('../../../assets/image/Navbar/bg-curve-top.png') no-repeat center center;
//     background-size: cover;
// }
</style>
